import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxGlideModule } from 'ngx-glide';
import { MatIconModule } from '@angular/material/icon';
import { UtilService } from 'src/app/shared/services';
import { SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-hf-benefit-detail',
  standalone: true,
  imports: [
    CommonModule,
    NgxGlideModule,
    MatIconModule,
    SwiperModule
  ],
  templateUrl: './hf-benefit-detail.component.html',
  styleUrls: ['./hf-benefit-detail.component.scss']
})
export class HfBenefitDetailComponent {
  @Input() benefits;
  @Input() desc;

  constructor (
    public util: UtilService
  ) {}

  config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 'auto',
    initialSlide: 1,
    navigation: true,
    keyboard: true,
    scrollbar: false,
    loop: true,
    observer: true,
    preloadImages: false,
    spaceBetween: 16,
    centeredSlides: false,
    pagination: false,
    breakpoints: {
      992: {
        slidesPerView: 'auto',
        centeredSlides: false,
        allowTouchMove: true,
        loop: false,
        initialSlide: 0,
        observer: true,
      },
      768: {
        slidesPerView: 1.6,
        centeredSlides: false,
        allowTouchMove: true,
        navigation: true,
        loop: false,
        initialSlide: 0,
        observer: true,
      },
    }
  };

  breakpoints = {
    600: { perView: 1.1, showArrows: false, gap: 15 },
    992: { perView: 2, focusAt: 0 }
  };
}
